import React from "react";
import Map from "./views/Map";

function App() {
  return (
    <div className="App">
      <Map />
    </div>
  );
}

export default App;
